import React from 'react';

import { Const } from '@gogame/components';
import { useCurrencyFormat } from '@gogame/intl-ts';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { useViewStateByPath } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

import { BudgetLabel } from './components';

const BudgetSum = ({ minWidthValue }) => {
  const currencyFormatter = useCurrencyFormat();
  const { levelPath = '' } = useGroup();
  const { budgetSum } = useViewStateByPath(levelPath);

  return (
    <Const label={'Budget'}>
      <BudgetLabel minWidthValue={minWidthValue}>
        {currencyFormatter(budgetSum)}
      </BudgetLabel>
    </Const>
  );
};

export default BudgetSum;
